import React from 'react';
import { Button, Skeleton } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import styles from './stats.module.css';

export const ROLE_LOCKED_TEXT = 'Esta área mostra números da conta inteira e fica com quem administra a conta.';

/**
 * Estados de uma seção enquanto os dados não estão prontos: esqueleto ao
 * carregar, aviso com "Tentar de novo" no erro, o cadeado do plano
 * (`lock` = retorno do usePlanLock) e o cadeado do papel ('roleLocked', Equipe).
 * Quando pronta, renderiza `children(data)`.
 */
const SectionState = ({ state, lock, onRetry, children }) => {
  if (!state || state.status === 'loading') {
    return (
      <div className={styles.skeleton}>
        {[0, 1, 2, 3].map((index) => <Skeleton key={index} variant="rounded" height={92} />)}
        <Skeleton className={styles.skeletonWide} variant="rounded" height={220} />
      </div>
    );
  }
  if (state.status === 'locked') {
    return lock ? lock.banner : null;
  }
  // Área da conta inteira para quem vê só a própria agenda: aparece, com o motivo
  if (state.status === 'roleLocked') {
    return (
      <div className={styles.roleLocked}>
        <LockOutlinedIcon fontSize="small" />
        <span>{ROLE_LOCKED_TEXT}</span>
      </div>
    );
  }
  if (state.status === 'error') {
    return (
      <div className={styles.error}>
        <span>Não foi possível carregar esta área agora.</span>
        {onRetry && <Button size="small" color="inherit" onClick={onRetry}>Tentar de novo</Button>}
      </div>
    );
  }
  return children(state.data, state.granularity);
};

export default SectionState;
